enum Products {
  perks = "PERKS",
  recognition = "RECOGNITION",
  medical = "MEDICAL",
  wellness = "WELLNESS",
  rewards = "FLEXIREWARDS"
}

export default Products
